module.exports = __webpack_public_path__ + "3361aa7ee2532a5099217647be249724.svg";